export function isAsyncHandler(handlers) {
    return 'callback' in handlers && typeof handlers.callback === 'function';
}
export function isRegExpAsyncHandler(h) {
    return 'regExp' in h;
}
export function isPlainAsyncHandler(h) {
    return !('regExp' in h) && !('type' in h);
}
export class TransportError extends Error {
    constructor(message, code) {
        super(message);
        this.code = code;
        this.component = 'Transport';
    }
}
